export default __webpack_public_path__ + "static/media/System-Analys-Illustration.3798c0ce.svg";